import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import {AdminLogin} from './components/AdminLogin'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      {/* <Route path='login' element={<Login />} /> */}
      <Route path='/admin/login' element={<AdminLogin />} />
      {/* <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} /> */}
      {/* <Route index element={<Login />} /> */}
      <Route index element={<AdminLogin />} />
    </Route>
  </Routes>
)

export {AuthPage}
